import React, { useContext, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import calendar from "../../assets/images/header/calendar.svg";
import user from "../../assets/images/user.svg";
import { todaysDate } from "../../utils/date";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getGreeting } from "../../utils/greeting";
import { handleConfirmation } from "../../utils/confirm";
import logout from "../../../src/assets/images/logout.svg";
import Badge from "@mui/material/Badge";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import "./Header.scss";
import {
  getAllNotification,
  updatedNotification,
  markRead,
} from "../../../src/http/user.service";
import { Box } from "@mui/material";
import { NotificationContext } from "../../context/NotificationsContext";
import userImg from "../../../src/assets/images/dashboard/liaiselogo.png";

const style = {
  width: "100%",
  maxWidth: 360,
  bgcolor: "background.paper",
};

const Sidebar = () => {
  const { notification, markAsRead } = useContext(NotificationContext);

  const Notification = notification.filter(
    (data) => data.to_user.seen == false
  );

  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();
  const currentUser = useSelector((data) => data.auth.currentUser);
  const greeting = getGreeting();

  const handleLogout = () => {
    handleConfirmation(
      () => {
        navigate("/logout");
        localStorage.clear();
      },
      () => {
        return false;
      }
    );
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = async () => {
    setOpen(false);
  };

  const handleClose1 = async () => {
    setOpen(false);
    const result = await markRead();
    markAsRead([]);
  };

  const AllNotification = () => {
    setOpen(false);
    navigate("/admin/notifications");
  };

  const handleUpdate = async (_id, user, seen) => {
    let data = {
      _id: _id,
      user: user,
      seen: seen,
    };
    await markAsRead(data);
    const notify = () => toast("Notification Updated Successfully");
    notify();
  };
  return (
    <div className="header">
      <div className="header-inner">
        <div className="left-section">
          <div>
            {greeting}, <span> Admin</span>
          </div>
          <div>
            <img src={calendar} />
            <span>{todaysDate}</span>
          </div>
        </div>
        <div className="right-section">
          <div className="profile-dropdown">
            <div className="profile-info">
              <div className="user"></div>
              <div className="notification-bell">
                <Stack spacing={2} direction="row">
                  <Badge badgeContent={Notification.length} color="primary">
                    <CircleNotificationsIcon
                      color="danger"
                      onClick={handleClickOpen}
                    />
                  </Badge>
                </Stack>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {Notification.length >= 1
                      ? "Hello Admin, Check Today's Notification's"
                      : "Hello Admin, No Notification's Yet"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {Notification.length > 0 ? (
                        <table className="notification-table">
                          <thead>
                            <tr>
                              {/* <th></th> */}
                              <th></th>
                              <th>Notification</th>
                              <th>Date & Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Notification?.map((document, index) => {
                              const messageIndex = index + 1;
                              const backgroundColor = document.to_user.seen
                                ? "white"
                                : "#eef7ff"; // Set background color based on seen property

                              const handleClick = () => {
                                const isAcceptRequestMessage =
                                  / accepted .+'s request\./.test(
                                    document.to_user.message
                                  );

                                if (isAcceptRequestMessage) {
                                  // Redirect to the desired path when the specific message is clicked
                                  navigate("/admin/user/tobeverifed");
                                }

                                // Also, update the notification to mark it as seen (if required)
                                handleUpdate(
                                  document._id,
                                  document.to_user.user,
                                  document.to_user.seen
                                );
                              };

                              const createdAt = new Date(document.createdAt);
                              const formattedDate =
                                createdAt.toLocaleDateString();
                              const formattedTime =
                                createdAt.toLocaleTimeString("en-US", {
                                  hour: "numeric",
                                  minute: "numeric",
                                  hour12: true,
                                });

                              return (
                                // Skip rendering the whole row if message starts with `{\n}`
                                document?.to_user?.message &&
                                  !document?.to_user?.message.startsWith(
                                    "{\n"
                                  ) ? (
                                  <React.Fragment key={document._id}>
                                    <tr
                                      style={{ backgroundColor }}
                                      onClick={handleClick}
                                    >
                                      <td>{messageIndex}</td>
                                      {/* <td>
                                          <div className='contact-img-wrap'>
                                            <div className='contact-img'>
                                              <img src={userImg} alt='User' />
                                            </div>
                                          </div>
                                        </td> */}
                                      <td>{document?.to_user?.message}</td>
                                      <td>
                                        <div>
                                          {formattedDate} {formattedTime}
                                        </div>
                                        <div></div>
                                      </td>
                                    </tr>
                                    <tr className="horizontal-line">
                                      <td colSpan="3"></td>
                                    </tr>
                                  </React.Fragment>
                                ) : null // Skip rendering the fragment (row)
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div>No Notifications Found</div>
                      )}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose1}>Close</Button>
                    {/* <Button onClick={handleClose1}>Mark All Read</Button> */}
                    <Button onClick={AllNotification}>
                      See All Notification
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              <div className="details">
                <span>
                  <i
                    className="bi bi-box-arrow-right"
                    onClick={handleLogout}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
